import React from 'react';

const CaseStudies = () => {
    const cases = [
        {
            icon: 'fa-plane',
            title: 'Travel Automation for Financial Institution',
            challenge: 'Manual travel reporting causing delays & duplication.',
            solution: 'Power Automate workflows, validation rules & dashboards.',
            outcomes: [
                { value: '78%', label: 'Less manual effort', color: 'green' },
                { value: '65%', label: 'Faster approvals', color: 'blue' }
            ]
        },
        {
            icon: 'fa-home',
            title: 'Student Accommodation Platform',
            challenge: 'Unreliable listings; low trust between students and landlords.',
            solution: 'Secure listing platform with landlord verification & booking workflows.',
            outcomes: [
                { icon: 'fa-arrow-up', label: 'Increased bookings', color: 'green' },
                { icon: 'fa-shield-alt', label: 'Trusted onboarding', color: 'blue' }
            ]
        },
        {
            icon: 'fa-sitemap',
            title: 'Facilities & Incident Lifecycle Digitisation',
            challenge: 'Fragmented incident reporting across departments.',
            solution: 'Standardised taxonomy, central intake & automated routing.',
            outcomes: [
                { icon: 'fa-check-circle', label: 'Standardised process', color: 'green' },
                { icon: 'fa-road', label: 'Roadmap initiated', color: 'blue' }
            ]
        }
    ];

    return (
        <section id="case-studies" style={{ padding: '80px 0', backgroundColor: '#0C1A36' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                    <span style={{ color: '#1746A2', fontWeight: 500 }}>Success Stories</span>
                    <h2 style={{
                        fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
                        fontWeight: 'bold',
                        color: 'white',
                        marginTop: '8px',
                        marginBottom: '16px'
                    }}>
                        Case Studies
                    </h2>
                    <p style={{ color: '#d1d5db', maxWidth: '600px', margin: '0 auto' }}>
                        Real results from real projects
                    </p>
                    <div style={{
                        width: '80px',
                        height: '4px',
                        backgroundColor: '#1746A2',
                        margin: '16px auto 0'
                    }}></div>
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
                    gap: '32px'
                }}>
                    {cases.map((caseStudy, index) => (
                        <div
                            key={index}
                            style={{
                                backgroundColor: 'white',
                                borderRadius: '16px',
                                overflow: 'hidden'
                            }}
                        >
                            <div style={{
                                backgroundColor: 'rgba(23, 70, 162, 0.1)',
                                padding: '24px'
                            }}>
                                <div style={{
                                    width: '56px',
                                    height: '56px',
                                    backgroundColor: '#1746A2',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '16px'
                                }}>
                                    <i className={`fas ${caseStudy.icon}`} style={{ fontSize: '24px', color: 'white' }}></i>
                                </div>
                                <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: '#0C1A36' }}>
                                    {caseStudy.title}
                                </h3>
                            </div>

                            <div style={{ padding: '24px' }}>
                                <div style={{ marginBottom: '16px' }}>
                                    <h4 style={{ fontWeight: 'bold', color: '#0C1A36', fontSize: '14px', marginBottom: '4px' }}>
                                        Challenge
                                    </h4>
                                    <p style={{ color: '#4b5563', fontSize: '14px' }}>{caseStudy.challenge}</p>
                                </div>
                                <div style={{ marginBottom: '16px' }}>
                                    <h4 style={{ fontWeight: 'bold', color: '#0C1A36', fontSize: '14px', marginBottom: '4px' }}>
                                        Solution
                                    </h4>
                                    <p style={{ color: '#4b5563', fontSize: '14px' }}>{caseStudy.solution}</p>
                                </div>

                                <div style={{ paddingTop: '16px', borderTop: '1px solid #f3f4f6' }}>
                                    <h4 style={{ fontWeight: 'bold', color: '#0C1A36', fontSize: '14px', marginBottom: '12px' }}>
                                        Outcomes
                                    </h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                        {caseStudy.outcomes.map((outcome, i) => (
                                            <div
                                                key={i}
                                                style={{
                                                    backgroundColor: outcome.color === 'green' ? '#f0fdf4' : '#eff6ff',
                                                    borderRadius: '8px',
                                                    padding: '12px',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {outcome.value ? (
                                                    <p style={{
                                                        fontSize: '24px',
                                                        fontWeight: 'bold',
                                                        color: outcome.color === 'green' ? '#16a34a' : '#1746A2'
                                                    }}>
                                                        {outcome.value}
                                                    </p>
                                                ) : (
                                                    <i
                                                        className={`fas ${outcome.icon}`}
                                                        style={{
                                                            color: outcome.color === 'green' ? '#16a34a' : '#1746A2',
                                                            fontSize: '20px',
                                                            marginBottom: '4px',
                                                            display: 'block'
                                                        }}
                                                    ></i>
                                                )}
                                                <p style={{ fontSize: '12px', color: '#4b5563' }}>{outcome.label}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CaseStudies;